import { useMemo } from 'react'
import { useFragment } from 'react-relay'
import { graphql } from 'relay-runtime'
import { Bubble } from '../../../../components/Bubble/Bubble'
import { deltaAsPercent, currencyFormat } from '../../../../display'
import { HookText_InsightV2$key } from './__generated__/HookText_InsightV2.graphql'

const hookTextInsightFragment = graphql`
  fragment HookText_InsightV2 on InsightV2 {
    id
    labelName
    delta
    contentUrls
    KPI
  }
`
type HookTextProps = {
  fragmentKey: HookText_InsightV2$key
}
export const HookText = ({ fragmentKey }: HookTextProps) => {
  const data = useFragment(hookTextInsightFragment, fragmentKey)

  const videoUrl = (data.contentUrls || [''])[0] || ''

  const statValue = useMemo(() => {
    if (!data.delta) return '-'

    if (data.KPI === 'AVG_DAILY_SPEND')
      return `${currencyFormat(data.delta, "USD")}`
    if (data.KPI === 'HOOK_RATE')
      return `${deltaAsPercent(data.delta)}%`
    return `${data.delta.toFixed(2)}`
  }, [data.delta, data.KPI])

  const statBubbleVariant = useMemo(() => {
    if (!data.delta) return 'grey'

    return data.delta > 0 ? 'green' : 'red'
  }, [data.delta])

  return (
    <div className="flex flex-col flex-none w-1/3 gap-3 p-3 border-b border-gray-200 rounded shadow-lg">
      <div className="flex items-center justify-end">
        <Bubble variant={statBubbleVariant} className="rounded-lg">
          {statValue}
        </Bubble>
      </div>

      <div className="flex gap-4">
        <video
          className="object-cover w-1/2 bg-gray-300"
          controls
        >
          <source src={videoUrl} />
        </video>

        <p className="text-sm text-black uppercase">{data.labelName}</p>
      </div>
    </div>
  )
}
